module.exports = __webpack_public_path__ + "img/newAppIcon.ae76edd5.png";